import ReactDOM from 'react-dom/client';
import React from 'react';
import { TenantContext } from '../../context/tenant-context';
import { v2Component } from '../../index';
import { OrderRequestForm } from './order-request-form';

export function initOrderRequestForm() {
  const elements = document.getElementsByName('order-request-form');
  elements.forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const setRootAttributes = (o: any) => {
        Object.keys(o).forEach((k) => {
          element.setAttribute(k, o[k]);
        });
      };
      const root = ReactDOM.createRoot(element);
      const { tenant, contextPath, ...props } = Object.assign({}, element.dataset) as any;
      root.render(
        v2Component(
          <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
            <OrderRequestForm {...props} setRootAttributes={setRootAttributes} />
          </TenantContext.Provider>,
        ),
      );
    }
  });
}
